import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const CesDetailedDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsCesDetailedDetails" */ 'modules/activityDetails/CesDetailedDetails/pages/CesDetailedDetails'
    )
)

const CesDetailedDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:cesId/:activityId`} component={CesDetailedDetails} />
      <Route exact path={`${routes.root}/:cesId`} component={CesDetailedDetails} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default CesDetailedDetailsRouting
